import React from "react"
import { Grid, InputLabel, MenuItem, Select, TextField } from "@material-ui/core"
import { SnoozeData, SnoozeTimeDescription, SnoozeTimeOptions } from "@/protocols/snooze"
import { getSnoozeTimeOptionContent, snoozeMenuOptions } from "@/utils/snooze"

type SnoozeTimeSelectorProps = {
	onTimeChange: (time: string) => void
	onTimeTypeChange: (snoozeOptions: SnoozeTimeDescription) => void
	onKeyDown: (event: React.KeyboardEvent<HTMLDivElement>) => void
	snoozeData: SnoozeData
}

const SnoozeTimeSelector: React.FC<SnoozeTimeSelectorProps> = ({
	onTimeChange,
	onTimeTypeChange,
	onKeyDown,
	snoozeData
}) => {
	const selectedSnoozeMenuOption = snoozeData.snoozeTime.timeOption.type
	const isSelectedSnoozeFullTimeOption = selectedSnoozeMenuOption === "fullTime"

	return (
		<Grid item xs={12}>
			<Grid container spacing={1}>
				<Grid item xs={12}>
					<InputLabel>Soneca por:</InputLabel>
				</Grid>
				<Grid item xs={12}>
					<Grid container spacing={2}>
						<Grid item xs={3}>
							<TextField
								value={snoozeData.snoozeTime.time}
								variant="outlined"
								type={selectedSnoozeMenuOption === "fullTime" ? "text" : "number"}
								fullWidth
								onChange={({ target }) => onTimeChange(target.value)}
								onKeyDown={onKeyDown}
								InputProps={{ inputProps: { min: 1, max: 9999 } }}
							/>
						</Grid>
						<Grid item xs={9}>
							<Select
								variant="outlined"
								fullWidth
								value={selectedSnoozeMenuOption}
								onChange={({ target }) => onTimeTypeChange(getSnoozeTimeOptionContent(target.value as SnoozeTimeOptions))}
							>
								{Object.keys(snoozeMenuOptions).map((option, index) => {
									const shouldHideFullTimeOption = option === "fullTime" && !isSelectedSnoozeFullTimeOption

									if (shouldHideFullTimeOption) {
										return
									}

									return (
										<MenuItem key={index} value={option}>
											{snoozeMenuOptions[option as SnoozeTimeOptions].title}
										</MenuItem>
									)
								})}
							</Select>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	)
}

export default SnoozeTimeSelector
